import { render, staticRenderFns } from "./ErrorInvoice.vue?vue&type=template&id=99db59e2&scoped=true&"
import script from "./ErrorInvoice.vue?vue&type=script&lang=js&"
export * from "./ErrorInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ErrorInvoice.vue?vue&type=style&index=0&id=99db59e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db59e2",
  null
  
)

export default component.exports